import navbar from '../../../playturbo/src/lang/ja/navbar'
import ptCommon from '../../../playturbo/src/lang/ja/common'
import versionlist from '../../../playturbo/src/lang/ja/versionList'
import websocket from '../../../playturbo/src/lang/ja/websocket'
import uploader from '../../../warehouse/src/lang/ja/uploader'
import cropperDialog from '../../../warehouse/src/lang/ja/cropperDialog'
import common from '../../../warehouse/src/lang/ja/common.js'
import custom from '../../../playturbo/src/lang/ja/custom'
import commonTemplate from '../../../playturbo/src/lang/ja/commonTemplate'
import animation from './ja/animation'
import audioCutter from './ja/audioCutter'
import audio from './ja/audio'
import board from './ja/board'
import image from './ja/image'
import psNavbar from './ja/navbar'
import layerManager from './ja/layerManager'
import layoutEditor from './ja/layoutEditor'
import leftPane from './ja/leftPane'
import globalSetting from './ja/globalSetting'
import animationSetting from './ja/animationSetting'
import designSetting from './ja/designSetting'
import eventSetting from './ja/event-setting/index'
import sceneSetting from './ja/sceneSetting'
import sceneManager from './ja/sceneManager'
import sequenceFrame from './ja/sequenceFrame'
import text from './ja/text'
import utils from './ja/utils'
import video from './ja/video'
import particle from './ja/particle'
import particleParent from './ja/particleParent'
import resourceManagers from './ja/resourceManager'
import preView from './ja/preview'
import iconText from './ja/icon'
import mixin from './ja/mixin'
import commonNavbar from '@/lang/ja/downloadBasic'
import basic from '@com/lang/ja/basic'
import track from '@com/lang/ja/track'
import creative from '@pt/lang/ja/creative'
import gamePlay from '@pt/lang/ja/gamePlay'
import leftMenu from '@pt/lang/ja/leftMenu'
import exportHistory from '@pt/lang/ja/exportHistory'
import recordProject from '@pt/lang/ja/recordProject'
import videoProject from '@pt/lang/ja/videoProject'
import playableProject from '@pt/lang/ja/playableProject'
import promoteManagement from '@pt/lang/ja/promoteManagement'
import assetLibrary from '@pt/lang/ja/assetLibrary'
import playableAds from '@pt/lang/ja/playableAds'
import whole from '@pt/lang/ja/whole'
import ps from './ja/ps'
import taskCenter from '@pt/lang/ja/taskCenter'
import pushDialog from '@pt/lang/ja/pushDialog'
import authAccount from '@pt/lang/ja/authAccount'

// import workbenchs from '@com/lang/zh/workbench'
import resourceManager from '@com/lang/ja/resourceManager'
import drawLine from './ja/drawLine'
import box2d from './ja/box2d'
import billing from '@pt/lang/zh/billing'
import profile from '@pt/lang/zh/profile'
import dashboard from '@pt/lang/ja/dashboard'
import playComponent from './ja/playComponent'
import erase from './ja/erase'
import carousel from './ja/carousel'
import park from './ja/park'
import puzzle from './ja/puzzle'
import shelves from './ja/shelves'
import iv from './ja/interactive-video'

export default {
  basic,
  track,
  ps,
  // workbenchs,
  resourceManager,

  commonNavbar,
  common,
  uploader,
  cropperDialog,
  playTurbo: {
    navbar,
    common: ptCommon,
    custom,
    versionlist,
    commonTemplate,
    pushDialog,
    authAccount,
    websocket,
    creative,
    gamePlay,
    exportHistory,
    leftMenu,
    recordProject,
    videoProject,
    playableProject,
    promoteManagement,
    assetLibrary,
    whole,
    playableAds,
    taskCenter,
    billing,
    profile,
    dashboard,
  },
  icon: {
    iconText,
  },
  preview: {
    preView,
  },
  workbench: {
    animation,
    audio,
    audioCutter,
    board,
    image,
    psNavbar,
    layerManager,
    leftPane,
    globalSetting,
    animationSetting,
    designSetting,
    eventSetting,
    sceneSetting,
    sceneManager,
    layoutEditor,
    sequenceFrame,
    text,
    utils,
    video,
    particle,
    particleParent,
    resourceManagers,
    mixin,
    drawLine,
    box2d,
    playComponent,
    erase,
    carousel,
    park,
    puzzle,
    shelves,
  },
  interactiveVideo: {
    iv,
  },
}
